/**
 * import and init global mixins
 */

import Vue from 'vue';

import currentUser from '../mixins/currentUser';

Vue.mixin(currentUser);
